import Request from 'api/Request';

export interface GetScrapedSchoolsResponse {
    schools: string[];
    organization_name: string | null;
}

export default function getScrapedSchools(jobId: string) {
    return Request.get<GetScrapedSchoolsResponse>(
        `/workouts/track-events/scraped-schools/${jobId}`,
    );
}
